import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPackageTypes, IPackageTypesState } from "./packagetypeModel";
import {
  createPackageTypes,
  deletePackageTypes,
  getAllActivePackageTypes,
  getAllPackageTypes,
  getPackageTypesByID,
  PackageTypesActiveInactive,
  updatePackageTypes,
} from "./services/packagetype.services";

const initialState: IPackageTypesState = {
  loading: false,
  formLoading: false,
  error: "",
  PackageTypesList: [],
  PackageTypesID: null,
  PackageTypesDetail: {
    package_type: "",
    isactive: 1,
  },
};

const packagetypeSlice = createSlice({
  name: "packagetype",
  initialState,
  reducers: {
    clearPackageTypesDetails: (state) => {
      state.PackageTypesDetail = initialState.PackageTypesDetail;
    },
    setPackageTypesID: (state, action) => {
      state.PackageTypesID = action.payload;
    },
    clearPackageTypesID: (state) => {
      state.PackageTypesID = initialState.PackageTypesID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPackageTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPackageTypes.fulfilled,
      (state, action: PayloadAction<IPackageTypes[]>) => {
        state.loading = false;
        state.PackageTypesList = action.payload || [];
      }
    );
    builder.addCase(getAllPackageTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PackageTypesList = [];
    });
    builder.addCase(getAllActivePackageTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivePackageTypes.fulfilled,
      (state, action: PayloadAction<IPackageTypes[]>) => {
        state.loading = false;
        state.PackageTypesList = action.payload || [];
      }
    );
    builder.addCase(getAllActivePackageTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PackageTypesList = [];
    });
    builder.addCase(createPackageTypes.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createPackageTypes.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createPackageTypes.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updatePackageTypes.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updatePackageTypes.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updatePackageTypes.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deletePackageTypes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deletePackageTypes.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deletePackageTypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(PackageTypesActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(PackageTypesActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(PackageTypesActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getPackageTypesByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getPackageTypesByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.PackageTypesDetail = action.payload;
    });
    builder.addCase(getPackageTypesByID.rejected, (state, action) => {
      state.formLoading = false;
      state.PackageTypesDetail = initialState.PackageTypesDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearPackageTypesDetails,
  setPackageTypesID,
  clearPackageTypesID,
} = packagetypeSlice.actions;
export default packagetypeSlice.reducer;
